/** 图片验证码 **/
<template>
	<div class="BasicInput">
			123
	</div>
</template>

<script>
export default {
  name: 'RevenueContent',
  props: {
			
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

</style>

<i18n>
{
  "en": {

  },
  "zn": {
		
  }
}
</i18n>


